




































































import BuilderFormGroup from "@tool/Builder/sections/BuilderFormGroup.vue";
import CopyInputGroup from "@base/Components/CopyInputGroup.vue";
import {computed, defineComponent, PropType, ref} from "@vue/composition-api";
import useBuilderStore from "@tool/store/useBuilderStore";
import VueScrollTo from "vue-scrollto";
import {BuilderUrlInterface} from "@tool/Builder/Builder.types";
import useRequiresUpgradeAlerts from "@tool/Helpers/useRequiresUpgradeAlerts";

export default defineComponent({
    components: {
        BuilderFormGroup,
        CopyInputGroup
    },
    emits: [
        'saved-url',
    ],
    props: {
        destinationUrl: {
            type: String,
            required: true
        },
        fullUrl: {
            type: String,
            required: true
        },
        savedUrlModel: {
            type: Object as PropType<BuilderUrlInterface>,
            required: false
        },
        showSavedUrlGroup: {
            type: Boolean,
            default: true
        }
    },
    setup(props, {emit}) {

        const isLoading = ref(false);

        const disableInputs = computed(() => {
            return props.fullUrl === '' || isLoading.value === true;
        });

        const utmTagsOnly = computed(() => {
            return props.fullUrl.replace(props.destinationUrl, '')
                    .replace(/^\?/, '');
        });

        const shortUrl = computed(() => {
            return props.savedUrlModel && props.savedUrlModel.shorturls.length > 0 ? props.savedUrlModel.shorturls[0] : null;
        });

        const shortUrlLink = computed(() => {
            return shortUrl.value === null ? '' : `${shortUrl.value.short_url}`;
        });

        const BuilderStore = useBuilderStore();

        const onSaveOrShorten = async (command: 'save' | 'shorten') => {
            if (command === 'shorten' && BuilderStore.project.value === null) {
                BuilderStore.showModalNeedToRegister.value = true;
                return;
            }

            isLoading.value = true;

            const needsToSaveUrl = !props.savedUrlModel;

            const url = props.savedUrlModel ? props.savedUrlModel : await BuilderStore.saveUrl(props.destinationUrl, props.fullUrl);

            if (needsToSaveUrl) {
                emit('saved-url', url);
            }

            if (command === 'shorten') {
                if (!BuilderStore.projectPermissions.value.canManageShorturls) {
                    return useRequiresUpgradeAlerts().shorturlsManagement(BuilderStore.project.value!.team_id);
                }
                await BuilderStore.shortenUrl(url);
            }

            isLoading.value = false;

        }


        const scrollToBuilderHistory = () => {
            VueScrollTo.scrollTo("#builder-section-history", 1000, {
                offset: -20
            });
        }

        return {
            disableInputs,
            utmTagsOnly,
            shortUrl,
            shortUrlLink,

            onSaveOrShorten,
            scrollToBuilderHistory,

        }
    }
});
